<template>
<div class="card">
    <p>Aqui você poderá configurar como deseja receber os Potis da sua empresa.</p>
    
    <div class="notifications-collapse">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="Notificações de Tarefas por e-mail" name="1">
            <div>
              Enviamos ao seu e-mail todos os dias pela manhã informações relacionadas as tarefas da sua empresa.                
            </div>
            <div>
                <el-switch v-model="activeTaskEmail" /> Ativar
            </div>
          </el-collapse-item>

          <el-collapse-item title="Notificações de lançamentos" name="2">
            <div>
              Deseja receber notificações de lançamentos de novas funcionalidades em seu e-mail?
            </div>
            <div>
                <el-switch v-model="activeLaunchEmail" /> Ativar
            </div>
          </el-collapse-item>
          <el-collapse-item title="Dicas de Produtividade" name="3">
            <div>
              Deseja receber dicas de produtividade em seu e-mail?
            </div>
            <div>
                <el-switch v-model="activeBlogEmail" /> Ativar
            </div>            
          </el-collapse-item>          
        </el-collapse>
      </div>
    
</div>
</template>
<script>
export default {
    name: 'SettingsNotifications',
    data() {
        return {
            activeNames: 1,
            activeTaskEmail: false,
            activeLaunchEmail: false,
            activeBlogEmail: false
        }
    },
    methods: {
        handleChange(val) {
            this.activeNames = val;
        }
    }
}
</script>
<style>
.card {
    background: #fff;
    padding: 10px 0;
    border-radius: 5px;
    font-size: 14px;
}
.card p {
    color: #666;
    padding: 10px;
}
.notifications-collapse {
    padding: 10px
}
.el-collapse-item__header {
    font-weight: bold;
}
</style>